export default __webpack_public_path__ + "static/torii-3-721ea85ee2ed2a6004f65c57564768f6.jpg";